import { useQuery } from '@tanstack/react-query';
import { getWorkEnvironmentRisk } from '../../api/workEnvironmentQueries';

export const WorkEnvironmentRiskQueryKey = 'WORK_ENVIRONMENT_RISK';

export const useWorkEnvironmentRiskQuery = (surveyId: number, language: string, { enabled = true } = {}) =>
  useQuery({
    queryKey: [WorkEnvironmentRiskQueryKey, surveyId, language],
    queryFn: () => getWorkEnvironmentRisk(surveyId, language),
    enabled,
    // The risk is calculated within a minute after the survey closes
    refetchInterval: (query) => (query.state.data && !query.state.data.calculatedAt ? 30_000 : false),
  });
